import { render, staticRenderFns } from "./PolizasSGForm.vue?vue&type=template&id=12ea619a&scoped=true&"
import script from "./PolizasSGForm.vue?vue&type=script&lang=js&"
export * from "./PolizasSGForm.vue?vue&type=script&lang=js&"
import style0 from "./PolizasSGForm.vue?vue&type=style&index=0&id=12ea619a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ea619a",
  null
  
)

export default component.exports